jQuery(document).ready(function ($) {
  // Contact modal
  var $body = $("body");
  var $html = $("html");

  $(".contact-modal__label").on("click", function () {
    $body.toggleClass("modal-open");
  });

  $html.on("click", function (e) {
    if (!$(e.target).closest(".contact-modal").length) {
      if ($body.hasClass("modal-open")) {
        $body.removeClass("modal-open");
      }
    }

    if (
      !$(e.target).closest(".sub-menu").length &&
      !$(e.target).closest(".menu-item-has-children").length
    ) {
      $(".sub-menu").removeClass("open");
    }
  });

  // Home
  if ($body.hasClass("home")) {
    var $readMore = $(".hero--home").find(".icon--read-down");
    var $testimonials = $(".slider");

    $readMore.on("click touchend", function (e) {
      var aanbodTop = $(".block--aanbod").offset().top;
      e.preventDefault();
      $html.stop().animate({ scrollTop: aanbodTop }, 700, "swing");
    });

    $testimonials.slick({
      speed: 500,
      fade: true,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 6000,
      arrows: false,
      dots: true,
    });

    var $typed = $(".typed");
    var strings = $typed.data("words");
    stringsArray = strings.split(",");
    stringsArray.pop(); // remove last entry

    $(".typed").typed({
      strings: stringsArray,
      // Optionally use an HTML element to grab strings from (must wrap each string in a <p>)
      stringsElement: null,
      // typing speed
      typeSpeed: 40,
      // time before typing starts
      startDelay: 0,
      // backspacing 2speed
      backSpeed: 30,
      // time before backspacing
      backDelay: 800,
      // loop
      loop: true,
      // show cursor
      showCursor: false,
      // attribute to type (null == text)
      attr: null,
      // either html or text
      contentType: "html",
      shuffle: true,
    });
  }

  //get URL and replace strings based on LANG
  var $urlGetter = window.location.href;
  console.log($urlGetter);

  // Menu
  var $parent = $(".menu-item-has-children").find(".nav-main-link");
  var $submenu = $(".sub-menu");

  $parent.on("click", function (e) {
    e.preventDefault();

    var $this = $(this).next(".sub-menu");

    if ($this.hasClass("open")) {
      $this.removeClass("open");
    } else {
      $submenu.removeClass("open");
      $this.addClass("open");
    }
  });

  var $menuButton = $(".menu-mobile--menu").find(".menu-button");

  $menuButton.on("click", function (e) {
    $body.toggleClass("menu-open");
  });

  // Contact button mobile
  var $contactButton = $(".menu-mobile--contact__button");

  $contactButton.on("click", function (e) {
    $body.toggleClass("contact-open");
  });

  // Social sharing
  $(".sharing-icons")
    .find("a")
    .on("click", function (e) {
      e.preventDefault();

      if ($(this).hasClass("icon--facebook")) {
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" +
            window.location.href,
          "newwindow",
          "width=400, height=600"
        );
      }

      if ($(this).hasClass("icon--linkedin")) {
        window.open(
          "http://www.linkedin.com/shareArticle?mini=true&url=" +
            window.location.href,
          "newwindow",
          "width=400, height=600"
        );
      }

      if ($(this).hasClass("icon--whatsapp2")) {
        window.open(
          "https://api.whatsapp.com/send?&text=Bekijk%20deze%20pagina: " +
            window.location.href,
          "newwindow",
          "width=400, height=600"
        );
      }
    });
});

(function ($) {
  $(window).load(function () {
    const weekday = [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag",
    ];

    const d = new Date();
    let day = weekday[d.getDay()];
    console.log("day");

    var $body = $("body");
    var $window = $(window);
    var $contactModalLabel = jQuery(".contact-modal__label");

    if ($body.hasClass("home")) {
      var blockAanbodTop = $(".block--aanbod").offset().top;

      $window.on("scroll", function () {
        if ($window.scrollTop() > blockAanbodTop - 100) {
          $contactModalLabel.addClass("active");
        } else {
          $contactModalLabel.removeClass("active");
        }
      });
    } else {
      $contactModalLabel.addClass("active");
    }
  });
})(jQuery);
